import { UserSettings } from 'src/types/UserSettings.ts';
import { getPriceValue } from 'src/modules/checkout/getPriceValue.ts';
import { ActuatorAccessoriesPageData } from 'src/actuators/accessories/ActuatorAccessoriesPageMapping.ts';
import { LocationState } from 'src/actuators/LocationState.ts';
import { Accessory, prepareAccessories } from 'src/common/prepareAccessories.ts';
import { sortAccessories } from 'src/modules/common/utils/sortAccessories.ts';
import { subtotalAccessories } from 'src/common/subtotalAccessories.ts';

export const calculateTotals = (
    {
        actuator,
        accessories: actuatorAccessories,
    }: ActuatorAccessoriesPageData['accessories'],
    userSettings: UserSettings,
    checkoutState: LocationState,
    currency: string | null,
): {
    subtotal: number;
    accessoriesSubtotal: number;
    total: number;
    currentCurrency: string;
    accessories: Accessory<ActuatorAccessoriesPageData['accessories']['accessories']['0']>[];
    pricePerUnit: number;
} => {
    const actuatorPrice = getPriceValue(actuator, userSettings.shoppingCenter as keyof typeof actuator, currency);
    const currentCurrency = actuatorPrice?.currency || currency || 'USD';
    const pricePerUnit = actuatorPrice ? actuatorPrice.value : 0;
    const subtotal = (actuatorPrice ? actuatorPrice.value : 0) * checkoutState.qty;

    const accessories = prepareAccessories<ActuatorAccessoriesPageData['accessories']['accessories']['0']>(
        actuatorAccessories,
        checkoutState.selectedAccessories,
        userSettings,
        currency,
        (a, b) => sortAccessories(a.accessory, b.accessory),
    );

    const accessoriesSubtotal = subtotalAccessories<
    ActuatorAccessoriesPageData['accessories']['accessories']['0']['item']
    >(accessories);

    const total = subtotal + accessoriesSubtotal;

    return {
        subtotal,
        accessoriesSubtotal,
        total,
        currentCurrency,
        accessories,
        pricePerUnit,
    };
};
